import { render, staticRenderFns } from "./PaymentMethodTitle.vue?vue&type=template&id=49fb3ac0"
import script from "./PaymentMethodTitle.vue?vue&type=script&lang=js"
export * from "./PaymentMethodTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports